import { Button } from "reactstrap";
import { packageButton } from "../styles/mainStyles";

function ButtonPackage({ onClick, title }) {
    return (
        <>
            <Button
                onClick={onClick}
                style={packageButton}
                onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseOut={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
                }
            >
                {title}
            </Button>
        </>
    );
}

export default ButtonPackage;
